import React from 'react';
import PropTypes from 'prop-types';
import { EmptyState } from 'onefaceui-react-components';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';

import { getResourceTo } from 'react/utils/chatUtils';
import { actionCreators as actionsModals } from 'react/api/actions/modals';

import { PanelTable, TextLink } from '../styles';

export function EquipmentsPanel({ equipment, eventId }) {
  const dispatch = useDispatch();
  const goToEvent = () => {
    dispatch(
      push(`/TrackEquipmentMapsDisplay/${equipment.id}/event/${eventId}`)
    );
    dispatch(
      actionsModals.closeModal({
        modalKey: 'eventDetails'
      })
    );
  };

  if (!equipment || !eventId) {
    return <EmptyState />;
  }

  return (
    <PanelTable>
      <table>
        <tbody>
          <tr>
            <td>{getResourceTo('equipment.key')}</td>
            <td>
              <TextLink size="xs" onClick={goToEvent}>{equipment?.key}</TextLink>
            </td>
          </tr>
          <tr>
            <td>{getResourceTo('equipment.description')}</td>
            <td>{equipment?.description}</td>
          </tr>
          <tr>
            <td>{getResourceTo('equipment.organization')}</td>
            <td>{equipment?.organization?.description}</td>
          </tr>
          <tr>
            <td>{getResourceTo('equipment.equipmenttype')}</td>
            <td>{equipment?.equipmentType?.description}</td>
          </tr>
        </tbody>
      </table>
    </PanelTable>
  );
}

EquipmentsPanel.propTypes = {
  equipment: PropTypes.object,
  eventId: PropTypes.number
};
